module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jump"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7a0ca96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-jump/src/Jump.vue
// module id = 470
// module chunks = 40